import { IS_MAC } from 'constants/commonConstans'

export const isCtrl = (
  event?: React.MouseEvent | React.KeyboardEvent | MouseEvent | KeyboardEvent,
) => {
  if (IS_MAC) {
    return event?.metaKey
  }

  return event?.ctrlKey
}
